import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Axios from 'axios';
import { isCacheValid, getCacheKey } from '../cacheUtils';

export const fetchSignupData = createAsyncThunk(
  'signupData/fetch',
  async (filters = {}, { getState, rejectWithValue }) => {
    const state = getState().signupData;
    const cacheKey = getCacheKey(filters);

    if (isCacheValid(state.lastFetched[cacheKey])) {
      return { data: state.data[cacheKey], cacheKey, cached: true };
    }

    try {
      const params = new URLSearchParams();
      if (filters.page) params.append('page', filters.page);
      if (filters.limit) params.append('limit', filters.limit);
      if (filters.company_size) params.append('company_size', filters.company_size);
      if (filters.company_type) params.append('company_type', filters.company_type);
      if (filters.search) params.append('search', filters.search);

      const response = await Axios.get(`/api/dashboard/signup-promotional-data?${params.toString()}`);
      return { data: response.data.data, cacheKey, cached: false };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch signup data');
    }
  }
);

const signupDataSlice = createSlice({
  name: 'signupData',
  initialState: {
    data: {},
    loading: false,
    error: null,
    lastFetched: {},
  },
  reducers: {
    invalidateCache: (state) => {
      state.lastFetched = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSignupData.pending, (state, action) => {
        const cacheKey = getCacheKey(action.meta.arg);
        if (!state.data[cacheKey]) state.loading = true;
      })
      .addCase(fetchSignupData.fulfilled, (state, action) => {
        const { data, cacheKey, cached } = action.payload;
        if (!cached) {
          state.data[cacheKey] = data;
          state.lastFetched[cacheKey] = Date.now();
        }
        state.loading = false;
      })
      .addCase(fetchSignupData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { invalidateCache: invalidateSignupDataCache } = signupDataSlice.actions;
export default signupDataSlice.reducer;